import { Component } from 'preact';
import Header from '../../header/Header';
import MobileVideo from '../../mobileVideo/MobileVideo';
import Footer from '../../footer/Footer';
import Timeline from '../../timeline/Timeline';
import Video from '../../video/Video';
import style from './style'
import { useEffect } from 'preact/hooks';
import Banner from '../../banner/Banner';

const Site = (props) => {
    const { site } = props;

    useEffect(() => {
        if (Number(props.site) > 0) {
            window.location.hash = `episode=${props.site}`;
        }
    }, [site]);

    const getVideoId = () => {
        if (props.site === 1) {
            return 'hdngdbzayHA';
        } else if (props.site === 2) {
            return 'PeF8GmV9rXc';
        } else if (props.site === 3) {
            return '4tPtg7C__Bo';
        } else if (props.site === 4) {
            return '4yICRafN9BE';
        } else if (props.site === 5) {
            return '9Ep4tG7fapg';
        } else if (props.site === 6) {
            return 'q6meaxdXyM0';
        } else if (props.site === 7) {
            return 'gkux3LKIZZk';
        }

    }

    const wOverlay = () => { return props.overlayVisible ? style['main-w-overlay--'+props.site] : ''};

    return (
        <div class={`${style['main']} ${style['main--' + site]} ${wOverlay()}`}>
            <Header
                site={site}
                setOverlay={props.setOverlay}
                overlayVisible={props.overlayVisible}
                closeOverlay={props.closeOverlay}
            />
            <div class={`${style['main__wrapper']} ${style['main__wrapper--' + site]}`}>
                <MobileVideo
                        url={`https://www.youtube.com/watch?v=${getVideoId()}?enablejsapi=1`}
                        site={site}
                        id={getVideoId()}
                />
                <div class={`${style['main__video']} ${style['main__video--' + site]}`}>
                    <div class={`${style['main__episode-name']} ${style['main__episode-name--' + site]}`}>
                        <span>холивар</span>
                    </div>
                    <Video
                        url={`https://www.youtube.com/watch?v=${getVideoId()}?enablejsapi=1`}
                        site={site}
                        id={getVideoId()}
                    />
                    <Banner site={site}/>
                </div>
                <Timeline site={site} handleSiteChange={props.handleSiteChange} loadedImages={props.loadedImages}/>
            </div>
            <Footer site={site} overlayVisible={props.overlayVisible}/>
        </div>
    )
};

export default Site;
